export const PORTVILLE_APPLICATIONS_LAST_SCROLL_KEY = 'admin:portville-applications:last-scroll';
